<div class="indicator-container avitium-bg-color rounded-circle" [ngClass]="{'top-right' : !position, position : position, 'size40' : size40}" [ngStyle]="{ 'margin-top': marginTop, 'margin-left': marginLeft, width, height }">
  <div class="indicator-text" [attr.style]="'font-weight: ' + fontWeight + '; font-size:' + fontSize + ' !important'">
    {{text}}
  </div>
</div>
